import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);

function injectHeadLinks() {
  if (typeof document === "undefined") return;

  const links: Array<{ rel: string; href: string; type?: string; sizes?: string }> = [
    { rel: "icon", type: "image/png", sizes: "32x32", href: "/favicon.ico" },
    { rel: "apple-touch-icon", sizes: "180x180", href: "/apple-touch-icon.png" },
    { rel: "manifest", href: "/manifest.webmanifest" },
  ];

  for (const attrs of links) {
    const link = document.createElement("link");
    link.rel = attrs.rel;
    link.href = attrs.href;
    if (attrs.type) link.type = attrs.type;
    if (attrs.sizes) link.setAttribute("sizes", attrs.sizes);
    document.head.appendChild(link);
  }
}

injectHeadLinks();

if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/provider-sw.js");
  });
}
